import angular from 'angular';
import template from './template.html';
import './style.scss';

export class SearchFilterToolbar {
    /* @ngInject */
    constructor($scope) {
        this.$scope = $scope;
    }

    $onChanges() {
        this.$scope.searchCtrl = this.searchCtrl;
    }
}

export const SearchFilterToolbarConfiguration = {
    template,
    bindings: {},
    require: {
        searchCtrl: '^searchComponent',
    },
    controller: SearchFilterToolbar,
    controllerAs: 'searchFilterToolbarCtrl',
};

angular
    .module('TALENYA-FE')
    .component('searchFilterToolbar', SearchFilterToolbarConfiguration);
